import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Alert,
} from '@mui/material';
import { McpConnectorSummary } from '../services/api';

interface Props {
  target: McpConnectorSummary | null;
  onCancel: () => void;
  onConfirm: () => void;
}

/**
 * Confirming the disconnection of one member's AI client.
 *
 * A sibling of ConfirmRevokeDialog rather than a shared component with a prop,
 * because almost nothing about the copy carries over: there is no key prefix to
 * show, the consequence lands on a colleague rather than an integration, and —
 * unlike an API key — this IS undoable, in the one way the operator most needs
 * to know about. Telling them "cannot be undone" here would be wrong.
 */
const ConfirmDisconnectDialog: React.FC<Props> = ({ target, onCancel, onConfirm }) => {
  return (
    <Dialog open={!!target} onClose={onCancel} maxWidth="xs" fullWidth>
      <DialogTitle>Disconnect AI client</DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ mb: 2 }}>
          Disconnect <strong>{target?.keyName}</strong>? Their AI client stops being
          able to read their jobs or download their documents straight away, and any
          request it has in flight starts failing.
        </DialogContentText>
        <Alert severity="info">
          They can reconnect at any time by signing in from the app again.
        </Alert>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel}>Cancel</Button>
        <Button color="error" variant="contained" onClick={onConfirm}>
          Disconnect
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDisconnectDialog;
